// extracted by mini-css-extract-plugin
module.exports = {"productCart":"product-card_productCart__gWTO2","productCardImage":"product-card_productCardImage__AvtAw","tag":"product-card_tag__u4qa6"};